import { render, staticRenderFns } from "./NewPatient.vue?vue&type=template&id=12242d84&scoped=true"
import script from "./NewPatient.vue?vue&type=script&lang=js"
export * from "./NewPatient.vue?vue&type=script&lang=js"
import style0 from "./NewPatient.vue?vue&type=style&index=0&id=12242d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12242d84",
  null
  
)

export default component.exports